import { useContext } from "react";

import type { IAdminAuthContext } from "@/contexts/AdminAuthContext";
import { AdminAuthContext } from "@/contexts/AdminAuthContext";

export const useAdminAuth = (): IAdminAuthContext => {
  const context = useContext(AdminAuthContext);

  if (context === undefined) {
    throw new Error("useAdminAuth must be used within an AdminAuthProvider");
  }

  return context;
};
